import { useReactiveVar } from '@apollo/client';

import { AuthenticationState, Path, RedirectState, getPath, useAuthContinueUrl, useCurrentUser } from '@neo.tax/shared';

export const useOnboardingRedirect = (): RedirectState => {
  const { authenticationServiceState } = useReactiveVar(AuthenticationState.authenticationStateVar);
  const { loading, user } = useCurrentUser();

  // Mirrors useAuthRedirect: a SAML/OIDC sign-in completing on /enterprise-sso?inviteToken=…
  // needs to land on /accept-invitation, not the default /profile demo gate.
  const safeContinueUrl = useAuthContinueUrl();

  if (loading || authenticationServiceState.loading) {
    return { isLoading: true };
  }
  if (user) {
    if (safeContinueUrl) {
      return {
        isLoading: false,
        redirectTo: safeContinueUrl,
      };
    }
    if (user.userAttributes.isSsoOnboarding) {
      return {
        isLoading: false,
        redirectTo: getPath({ path: Path.PROFILE }),
      };
    }
    if (!user.organization && user.companies.length === 0) {
      return {
        isLoading: false,
        redirectTo: getPath({ path: Path.PROFILE }),
      };
    }
    return {
      isLoading: false,
      redirectTo: getPath({ path: Path.COMPANIES }),
    };
  }
  return {
    isLoading: false,
  };
};
